'use client';
import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import Button from '../ui/Button';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { label: 'Home', href: '/' },
    { label: 'Events & Initiatives', href: '/#events' },
    { label: 'Speakers', href: '/#speakers' },
    { label: 'Event Highlights', href: '/#event-highlights' },
    { label: 'Partners', href: '/#partners' },
    { label: 'About Us', href: '/#about' },
    { label: 'Contact Us', href: '/contact/' },
    
  ];

  // Smooth scroll
  const handleSmoothScroll = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string
  ) => {
    const [path, hash] = href.split('#');
    if (hash && window.location.pathname === path) {
      e.preventDefault();
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header data-component-id="src/components/common/Header.tsx:47:4" data-component-path="src/components/common/Header.tsx" data-component-line="47" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
      className={`w-full z-50 transition-all duration-300 ${
        isSticky
          ? 'fixed top-0 left-0 bg-white shadow-lg'
          : 'relative top-0 left-0 bg-transparent'
      }`}
    >
      <div data-component-id="src/components/common/Header.tsx:54:6" data-component-path="src/components/common/Header.tsx" data-component-line="54" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1150px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-0%22%7D" className="w-full max-w-[1150px] mx-auto px-4 sm:px-6 lg:px-0">
        <div data-component-id="src/components/common/Header.tsx:55:8" data-component-path="src/components/common/Header.tsx" data-component-line="55" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-between%20items-center%20py-4%20sm%3Apy-6%20lg%3Apy-%5B26px%5D%22%7D" className="flex justify-between items-center py-4 sm:py-6 lg:py-[26px]">
          {/* Logo */}
          <Link data-component-id="src/components/common/Header.tsx:57:10" data-component-path="src/components/common/Header.tsx" data-component-line="57" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%20gap-2%22%7D" href="/" className="flex items-center gap-2">
            <Image data-component-id="src/components/common/Header.tsx:58:12" data-component-path="src/components/common/Header.tsx" data-component-line="58" data-component-file="Header.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Fweb3growthguild.svg%22%2C%22alt%22%3A%22Web3%20Growth%20Guild%20Logo%22%2C%22className%22%3A%22h-%5B40px%5D%20w-auto%22%7D"
              src="/images/web3growthguild.svg"
              alt="Web3 Growth Guild Logo"
              width={194}
              height={48}
              className="h-[40px] w-auto"
              unoptimized
            />
          </Link>

          {/* Desktop Navigation */}
          <nav data-component-id="src/components/common/Header.tsx:69:10" data-component-path="src/components/common/Header.tsx" data-component-line="69" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20gap-%5B42px%5D%22%7D" className="hidden lg:flex items-center gap-[42px]">
            {menuItems.map((item, index) => (
              <Link data-component-id="src/components/common/Header.tsx:71:14" data-component-path="src/components/common/Header.tsx" data-component-line="71" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22text-%5B14px%5D%20lg%3Atext-%5B16px%5D%20font-medium%20text-header-text%20hover%3Atext-primary%20transition-colors%20duration-200%22%7D"
                key={index}
                href={item.href}
                onClick={(e) => handleSmoothScroll(e, item.href)}
                className="text-[14px] lg:text-[16px] font-medium text-header-text hover:text-primary transition-colors duration-200"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Join Button */}
          {/* <div className="hidden lg:block">
            <Link href='/contact/'>
            <Button className="pt-[6px] pr-[42px] pb-[6px] pl-[18px] flex items-center gap-2">
              <span>Join the Guild</span>
              <Image
                src="/images/pink-arrow.webp"
                alt="Join icon"
                width={24}
                height={28}
                unoptimized
              />
            </Button>
            </Link>
          </div> */}

          {/* Mobile Hamburger */}
          <button data-component-id="src/components/common/Header.tsx:99:10" data-component-path="src/components/common/Header.tsx" data-component-line="99" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20p-3%22%7D"
            className="lg:hidden p-3"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <div data-component-id="src/components/common/Header.tsx:104:12" data-component-path="src/components/common/Header.tsx" data-component-line="104" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-6%20h-6%20flex%20flex-col%20justify-center%20items-center%22%7D" className="w-6 h-6 flex flex-col justify-center items-center">
              <span data-component-id="src/components/common/Header.tsx:105:14" data-component-path="src/components/common/Header.tsx" data-component-line="105" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                className={`block w-6 h-0.5 bg-header-text transition-all duration-300 ${
                  isMobileMenuOpen ? 'rotate-45 translate-y-1.5' : ''
                }`}
              />
              <span data-component-id="src/components/common/Header.tsx:110:14" data-component-path="src/components/common/Header.tsx" data-component-line="110" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                className={`block w-6 h-0.5 bg-header-text mt-1 transition-all duration-300 ${
                  isMobileMenuOpen ? 'opacity-0' : ''
                }`}
              />
              <span data-component-id="src/components/common/Header.tsx:115:14" data-component-path="src/components/common/Header.tsx" data-component-line="115" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                className={`block w-6 h-0.5 bg-header-text mt-1 transition-all duration-300 ${
                  isMobileMenuOpen ? '-rotate-45 -translate-y-1.5' : ''
                }`}
              />
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <nav data-component-id="src/components/common/Header.tsx:127:8" data-component-path="src/components/common/Header.tsx" data-component-line="127" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22lg%3Ahidden%20relative%20top-full%20left-0%20w-full%20bg-white%20z-50%20border-t%20border-border-primary%22%7D" className="lg:hidden relative top-full left-0 w-full bg-white z-50 border-t border-border-primary">
          <div data-component-id="src/components/common/Header.tsx:128:10" data-component-path="src/components/common/Header.tsx" data-component-line="128" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20p-4%20space-y-4%22%7D" className="flex flex-col p-4 space-y-4">
            {menuItems.map((item, index) => (
              <Link data-component-id="src/components/common/Header.tsx:130:14" data-component-path="src/components/common/Header.tsx" data-component-line="130" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22text-sm%20font-normal%20text-header-text%20hover%3Atext-primary%20transition-colors%20duration-200%20py-2%20w-full%22%7D"
                key={index}
                href={item.href}
                onClick={(e) => handleSmoothScroll(e, item.href)}
                className="text-sm font-normal text-header-text hover:text-primary transition-colors duration-200 py-2 w-full"
              >
                {item.label}
              </Link>
            ))}
            
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
